const fadeElement = document.querySelector('#fade');

if (fadeElement) {
  const swiperFade = new Swiper('#fade', {
    loop: true,
    allowTouchMove: false,
    slidesPerView: 1,
    speed: 2000,

    autoplay: {
      delay: 11000,
      disableOnInteraction: false,
    },

    effect: 'fade',

    fadeEffect: {
      crossFade: true,
    },
  });
}


const sliderElement = document.querySelector('#slider');

if (sliderElement) {

  const slides = sliderElement.querySelectorAll('.swiper-slide');
  const slideCount = slides.length;

  if (slideCount <= 2) {
    sliderElement.classList.add('is-few');
  }

  const swiperSlider = new Swiper('#slider', {
    slidesPerView: 'auto',
    speed: 600,

    loop: slideCount > 2,
    centeredSlides: slideCount > 2,

    spaceBetween: 2,

    autoplay: {
      delay: 6000,
      disableOnInteraction: true,
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

}